var _rect, _path, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14.1207,
    rx: 5,
    fill: "#D9D9D9",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 5C22 2.23858 24.2386 0 27 0H58C60.7614 0 63 2.23858 63 5V58C63 60.7614 60.7614 63 58 63H27C24.2386 63 22 60.7614 22 58V5Z",
    fill: "#D9D9D9",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 16.2931,
    width: 20,
    height: 14.1207,
    rx: 5,
    fill: "#D9D9D9",
    fillOpacity: 0.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 48.8793,
    width: 20,
    height: 14.1207,
    rx: 5,
    fill: "#D9D9D9",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 32.5862,
    width: 20,
    height: 14.1207,
    rx: 5,
    fill: "#D9D9D9",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsIcon);
export default __webpack_public_path__ + "static/media/docs_icon.d1fdd2a1035820c221a16ec983814f9b.svg";
export { ForwardRef as ReactComponent };